module.exports = __webpack_public_path__ + "img/APP-ICON@3x.e8de29b2.png";